// Keep GTINs as text so significant leading zeros are preserved.
export const normalizeGtin = (value) => (value ?? '').replace(/\s/g, '')
